import React, { useState, useEffect } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { getProjectCompanyProfiles } from '@/services/projects';
import { CompanyProfileData } from '@/types';
import Select from 'react-select';
import { ProfileIcon } from '@/components/Icons';
import theme from './LinkToUnit.module.scss';

export interface LinkToUnitCompanyProfileProps {
    projectId: number | null;
    onProvidedByProfileIdChange: (id: number | null) => void;
    providedByProfileId: number | null;
}

export const LinkToUnitCompanyProfile: React.FC<LinkToUnitCompanyProfileProps> = ({
    projectId,
    onProvidedByProfileIdChange,
    providedByProfileId,
}) => {
    const [profiles, setProfiles] = useState<CompanyProfileData[]>([]);
    useEffect(() => {
        const loadData = async () => {
            setProfiles(await getProjectCompanyProfiles(projectId!));
        };

        if (projectId) {
            loadData();
        } else {
            setProfiles([]);
        }
    }, [projectId]);

    const options = profiles
        .filter((x) => x.permissions.canMakeOptionProvider)
        .map((p) => ({
            label: p.name,
            value: p.profileId,
        }));

    options.unshift({
        label: t`No company profile`,
        value: 0,
    });

    const selectedOption = providedByProfileId ? options.find((x) => x.value === providedByProfileId) : options[0];

    return (
        <Select
            formatOptionLabel={(o) => {
                if (!o.value) {
                    return (
                        <div className={theme.selectItem}>
                            <Trans>No company profile</Trans>
                        </div>
                    );
                }

                return (
                    <div className={theme.selectItem}>
                        <ProfileIcon sizeInPx={30} profileId={o.value} className={theme.profileIcon} /> {o.label}
                    </div>
                );
            }}
            classNamePrefix="r-s"
            className="react-select"
            styles={{
                control: () => ({
                    width: 'auto',
                    borderRadius: '4px',
                    border: '1px solid #DBDBDB',
                    display: 'flex',
                }),
            }}
            // defaultValue={options[0]}
            // "No company profile" uses the sentinel value 0; emit null so callers never
            // persist or submit 0 (there is no Profile with Id 0 -> FK_OptionGroup_Profile violation).
            onChange={(v) => onProvidedByProfileIdChange((v as any).value || null)}
            options={options}
            value={selectedOption}
        />
    );
};
